export default "__VITE_ASSET__84cf519e__"